import { axios, axios2 } from '@/lib/axios';

export const payReeipo = (data: { price: string; payment_token: string }) => {
  return axios2.post('/customer-api/pay-reeipo', data);
};
